import { Center, Flex, Grid, GridItem, Hide, Show, Text, Stepper, useSteps, Step, StepIndicator, StepStatus, StepIcon, StepNumber, Box, StepTitle, StepSeparator, Progress, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { MdChevronRight } from 'react-icons/md';
import { JobOverviewStage } from '../..';

interface IProps{
    jobStage: JobOverviewStage,
    isOrdering: boolean,
    isRightToCancel: boolean
}

export const JobStageStepper = (props: IProps) => {
    const defaultStages: Array<{title: string}> = [
        {title: 'Assessing'},
        {title: 'In Progress'},
        {title: 'Payment'}
    ]

    const [steps, setSteps] = useState<{title: string}[]>(defaultStages);

    const {activeStep, setActiveStep} = useSteps();

    useEffect(() => {
        let stages: Array<{title: string}> = [];
        stages.push({title: 'Assessing'});
        if (props.isRightToCancel) {
            stages.push({title: 'Right To Cancel'});
        }
        if (props.isOrdering) {
            stages.push({title: "Ordering"});
        }
        stages.push({title: "In Progress"});
        stages.push({title: "Payment"});

        setSteps(stages);
    }, [props.isOrdering, props.isRightToCancel]);

    useEffect(() => {
        let stageOffset: number = props.isOrdering ? 1 : 0;
        let rtcOffset: number = props.isRightToCancel ? 1 : 0;
        console.log(props);

        if (props.jobStage < JobOverviewStage.AwaitingEngineer){
            setActiveStep(0);
        } else if (props.jobStage < JobOverviewStage.RightToCancel){
            setActiveStep(0);
        } else if (props.jobStage < JobOverviewStage.Ordering){
            setActiveStep(0 + rtcOffset);
        } else if (props.jobStage < JobOverviewStage.WorkInProgress){
            setActiveStep(0 + rtcOffset + stageOffset);
        } else if (props.jobStage < JobOverviewStage.Payment){
            setActiveStep(1 + rtcOffset + stageOffset);
        } else if (props.jobStage < JobOverviewStage.Completed){
            setActiveStep(2 + rtcOffset + stageOffset);
        } else {
            setActiveStep(3 + rtcOffset + stageOffset);
        }
    }, [props.jobStage, props.isOrdering, steps]);

    return (
        <Flex w='full' position='relative' justify={'center'}>
            <Show above='md'>
                <Stepper index={activeStep} colorScheme='green' size='lg' w='80%'>
                    {steps.map((step, index) => (
                        <>
                            <Step key={index}>
                                <Flex direction={'column'} align={'center'}>
                                    <StepIndicator>
                                        <StepStatus
                                            complete={<StepIcon/>}
                                            incomplete={<StepNumber/>}
                                            active={<StepNumber/>}
                                        />
                                    </StepIndicator>

                                    <Box mt={2}>
                                        <StepTitle><b>{step.title}</b></StepTitle>
                                    </Box>
                                </Flex>

                                <StepSeparator/>
                            </Step>
                        </>
                    ))}
                </Stepper>
            </Show>
    
            <Hide above='md'>
                <VStack w='full'>
                    <Stepper index={activeStep} colorScheme='green' size={'md'} w='80%'>
                        {steps.map((step, index) => (
                            <Step key={index}>
                                <Flex direction={'column'} align={'center'}>
                                    <StepIndicator>
                                        <StepStatus
                                            complete={<StepIcon/>}
                                            incomplete={<StepNumber/>}
                                            active={<StepNumber/>}
                                        />
                                    </StepIndicator>
                                </Flex>

                                <StepSeparator/>
                            </Step>
                        ))}
                    </Stepper>

                    {activeStep > 0 && activeStep < steps.length &&
                        <Text mt={2} fontSize={'lg'}>{activeStep + 1} - <b>{steps[activeStep].title}</b></Text>
                    }
                </VStack>
            </Hide>
        </Flex>
    )
}

